
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { AlertItemProps } from "./types";
import {
  AlertDialog,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { DeleteConfirmation } from "./DeleteConfirmation";
import { useState } from "react";

export function AlertItem({ 
  alert, 
  onToggle, 
  isLoading, 
  currentGoldPrice, 
  currentSilverPrice,
  onDelete 
}: AlertItemProps) {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const isAlertTriggered = () => {
    if (!currentGoldPrice || !currentSilverPrice) return false;
    
    const currentPrice = alert.metal === 'gold' 
      ? currentGoldPrice.price 
      : currentSilverPrice.price;
    
    if (alert.condition === 'above') {
      return currentPrice >= alert.targetPrice;
    } else {
      return currentPrice <= alert.targetPrice;
    }
  };

  const getMetalName = (metal: string) => {
    return metal === 'gold' ? 'Oro' : 'Argento';
  };

  const getConditionText = (condition: string) => {
    return condition === 'above' ? 'sopra' : 'sotto';
  };

  const handleDeleteClick = () => {
    setShowDeleteDialog(true);
  };

  const handleDeleteCancel = () => {
    setShowDeleteDialog(false);
  };

  const handleDeleteConfirm = () => {
    onDelete(alert.id);
    setShowDeleteDialog(false);
  };

  return (
    <div 
      className={`border rounded-lg p-4 ${
        isAlertTriggered() ? 'bg-red-50 border-red-200 dark:bg-red-950 dark:border-red-800' : ''
      }`}
    >
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-medium">
            {getMetalName(alert.metal)}: {alert.targetPrice.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' })}
          </h3>
          <p className="text-sm text-muted-foreground">
            Avvisa quando il prezzo è {getConditionText(alert.condition)} {alert.targetPrice.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' })}
          </p>
          
          {isAlertTriggered() && (
            <p className="text-sm font-medium text-red-600 dark:text-red-400 mt-1">
              Condizione soddisfatta! Il prezzo attuale è {alert.metal === 'gold' 
                ? currentGoldPrice?.price.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' })
                : currentSilverPrice?.price.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' })}
            </p>
          )}
        </div>
        
        <div className="flex items-center space-x-2">
          <Switch 
            checked={alert.isActive} 
            onCheckedChange={() => onToggle(alert.id)}
            disabled={isLoading}
          />
          
          <AlertDialog open={showDeleteDialog}>
            <AlertDialogTrigger asChild>
              <Button 
                variant="ghost" 
                size="icon"
                disabled={isLoading}
                onClick={handleDeleteClick}
              >
                <Trash2 className="h-4 w-4 text-muted-foreground" />
              </Button>
            </AlertDialogTrigger>
            <DeleteConfirmation
              isOpen={showDeleteDialog}
              onCancel={handleDeleteCancel}
              onConfirm={handleDeleteConfirm}
            />
          </AlertDialog>
        </div>
      </div>
    </div>
  );
}
